import { render } from "./ThreadUsersTableList.vue?vue&type=template&id=53e16958&scoped=true"
import script from "./ThreadUsersTableList.vue?vue&type=script&lang=js"
export * from "./ThreadUsersTableList.vue?vue&type=script&lang=js"

import "./ThreadUsersTableList.vue?vue&type=style&index=0&id=53e16958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e16958"]])

export default __exports__